import gql from 'graphql-tag';

export default gql`
  query ProgramSwitcherSelectionsV1($userId: String!) {
    ProgramSwitcherSelectionsV1Resource {
      get(id: $userId) {
        programId
        id
        program {
          id
          program {
            ... on ProgramsV1_enterpriseProgramMember {
              enterpriseProgram {
                thirdPartyOrganizationId
              }
            }
          }
        }
      }
    }
  }
`;
